import * as routes from 'src/routes';

export const getSigningCaseListPath = (url: string) => {
  if (url === routes.archivedSigningCaseView) {
    return routes.archive;
  } else {
    return routes.home;
  }
};
